<div [class]="animationShapeRight ? 'animationnew-shap' : 'animation-shap'">
  <div class="shap-bg"></div>
</div>
